<template>
  <div class="gaming-page-wrap">
    <div class="gaming-page">
      <GamingHeader @update="changeFilter"/>
      <component v-bind:is="currentGame" :filters="filters"></component>
      <GamingFooter />
    </div>
  </div>
</template>

<script>
import GamingHeader from '@/components/gaming/header.vue'
import GamingFooter from '@/components/gaming/footer.vue'
import Dota from './dota.vue'
import Lol from './lol.vue'
import Csgo from './csgo.vue'
import Kog from './kog.vue'

export default {
  name: 'Gaming',
  components: {
    GamingHeader,
    GamingFooter,
    Dota,
    Lol,
    Csgo,
    Kog
  },
  data () {
    return {
      filters: []
    }
  },
  computed: {
    currentGame () {
      let component = Dota
      switch ((this.$route.params.type || '').toLowerCase()) {
        case 'dota2':
          component = Dota
          break;
        case 'lol':
          component = Lol
          break;
        case 'csgo':
          component = Csgo
          break;
        case 'kog':
          component = Kog
          break;
        default:
          break;
      }
      return component
    }
  },
  methods: {
    changeFilter (arr) {
      this.filters = arr
    }
  },
  mounted () {
    $(".haed_gaming").addClass("nuxt-link-exact-active");
    $("footer").show();
  }
}
</script>

<style lang="less" scoped>
.gaming-page-wrap {
  background: #FBFBFF;
  min-height: 90vh;
}
.gaming-page {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
}
</style>